import * as React from 'react';
import { ImageFile } from 'react-dropzone';
import './Dropzone.css';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';
import { IdentificationDocumentDropzone } 
  from 'src/modules/commons/identification-document-file/IdentificationDocumentDropzone';
import 'src/modules/commons/identification-document-file/IdentificationDocumentForm.css';

interface IdentificationDocumentsFormComponentProps {
  formData: PhysicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  idFront?: File;
  idBack?: File;
}

class IdentificationDocumentsFormComponent extends React.Component<IdentificationDocumentsFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question45"
        >
          <div className="icon-title">
            <img
              alt="Euro"
              className="icon"
              src="/img/paper.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Documento de identidad
              </strong>
              <span className="d-arrow-up" />
            </h4>
            <div className="gap-20" />
          </div>
        </div>
        <div
          id="question45"
          className="collapse"
        >
          <p>
            Si tienes el documento de identidad escaneado por las dos caras en un mismo documento,
            por favor, sube el documento en los dos campos.
          </p>
          <div className="gap-10" />
          <div className="id-form-outter">
            <div className="id-form-inner-left">
              <IdentificationDocumentDropzone
                idFile={this.props.idFront}
                noIdFileText="Arrastra el anverso de tu NIF *"
                isIdFileText="Documento subido correctamente"
                noIdFileImg="/img/dni.png"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) { this.props.handleChange('idFront')(files[0]); }
                }}
                handleChange={() => this.props.handleChange}
              />
            </div>
            <div className="id-form-inner-right">
              <IdentificationDocumentDropzone
                idFile={this.props.idBack}
                noIdFileText="Arrastra el reverso de tu NIF *"
                isIdFileText="Documento subido correctamente"
                noIdFileImg="/img/dni2.png"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) { this.props.handleChange('idBack')(files[0]); }
                }}
                handleChange={() => this.props.handleChange}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

}

export default IdentificationDocumentsFormComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/IdentificationDocumentsForm.component.tsx